import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import PartyTooltip from '../tooltips/partyTooltip/PartyTooltip';
import { mapValidationFieldsToClassName } from '../../forms/inputValidations';
import './PartySelector.less';


class PartySelector extends Component {
  componentWillReceiveProps(nextProps) {
    if (!nextProps.last_business_name) {
      this.refs.last_business_name.value = '';
    }

    if (!nextProps.first_name) {
      this.refs.first_name.value = '';
    }

    if (!nextProps.middle_name) {
      this.refs.middle_name.value = '';
    }
  }

  onChange = (ref) => {
    const value = this.refs[ref].value;
    this.props.onChange({ [ref]: value });

    const { last_business_name, middle_name, first_name } = this.refs;

    // only add ', ' when we have first or middle names, otherwise use last_bussiness_name for party

    // join first and middle with space, or just use whichever one is entered
    const first_middle = _.filter([first_name.value, middle_name.value]).join(' ');
    // join lastname with whatever we got above, or just use whichever one is entered
    const party_name = _.filter([last_business_name.value, first_middle]).join(', ');
    this.props.onChange({ party_name });
  };

  render() {
    return (
      <div className="form-item">
        <label htmlFor="party-input" className="party-inputs-label">Party: </label>
        <input type="hidden" id="party-input" />
        <PartyTooltip className={this.props.tooltipClassName || ''}/>
        <div className="party-selector-container">
          <div className="party-selector-container-element">
            <label>Last / Business Name</label>
            <input type="text"
                   id="party_last_business_name"
                   maxLength="128"
                   ref="last_business_name"
                   onBlur={this.onChange.bind(this, 'last_business_name')}
                   className={this.props.classNameOfLastBusinessName}
            />
          </div>
          <div className="party-selector-container-element">
            <label>First Name</label>
            <input
              type="text"
              maxLength="128"
              ref="first_name"
              onBlur={this.onChange.bind(this, 'first_name')}
              className={this.props.classNameFirstName}
            />
          </div>
          <div className="party-selector-container-element">
            <label>Middle Name</label>
            <input type="text"
                   maxLength="128"
                   ref="middle_name"
                   onBlur={this.onChange.bind(this, 'middle_name')}
                   className={this.props.classNameMiddleName}
            />
          </div>
        </div>
      </div>
    )
  }
}

PartySelector.propTypes = {
  onChange: PropTypes.func,
  className: PropTypes.string,
};

PartySelector.defaultProps = {
  onChange: () => null,
  className: '',
};


function mapStateToProps(state) {
  return {
    classNameOfLastBusinessName: mapValidationFieldsToClassName(state, 'last_business_name', 'input-search').className,
    classNameFirstName: mapValidationFieldsToClassName(state, 'first_name', 'input-search').className,
    classNameMiddleName: mapValidationFieldsToClassName(state, 'middle_name', 'input-search').className,
    last_business_name: state.getIn(['pacerSearchResults', 'filters', 'last_business_name']),
    middle_name: state.getIn(['pacerSearchResults', 'filters', 'middle_name']),
    first_name: state.getIn(['pacerSearchResults', 'filters', 'first_name']),
  }
}


export default connect(mapStateToProps)(PartySelector)



/** WEBPACK FOOTER **
 ** ./src/components/search/FormElements/partySelector/PartySelector.js
 **/